// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loading {
    display: inline-block;
    width: 32px;
    height: 32px;
    border: 3px solid rgba(255, 255, 255, .3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
}
#loading.black {
    border-top-color: #000 !important;
}

@keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/loader/index.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,sBAAsB;IACtB,uCAAuC;IACvC,+CAA+C;AACnD;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ","sourcesContent":["#loading {\n    display: inline-block;\n    width: 32px;\n    height: 32px;\n    border: 3px solid rgba(255, 255, 255, .3);\n    border-radius: 50%;\n    border-top-color: #fff;\n    animation: spin 1s ease-in-out infinite;\n    -webkit-animation: spin 1s ease-in-out infinite;\n}\n#loading.black {\n    border-top-color: #000 !important;\n}\n\n@keyframes spin {\n    to {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes spin {\n    to {\n        -webkit-transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
